import { defaultDateFormat } from "../date-input/dateFormats";
export const defaults = {
    start: {
        label: "Start",
        layoutVariant: "inline",
        date: undefined,
        onDateChange: () => { }
    },
    end: { label: "End", layoutVariant: "inline", date: undefined, onDateChange: () => { } },
    calendarProps: {},
    dateFormat: defaultDateFormat,
    shouldValidateOnBlur: true
};
